import { Modal, ModalBody } from "reactstrap";

const MarkAsInProgressModal = ({ modal, toggle, submitHandler, isPending }) => {
  const closeHandler = () => {
    toggle();
  };

  return (
    <Modal isOpen={modal} toggle={closeHandler} centered>
      <ModalBody className="text-center">
        <div className="d-flex flex-column justify-content-center align-items-center gap-4 mt-3">
          <p className="mb-4 fs-5">
            Are you sure you want to mark this as {isPending ? "In Progress" : "Pending"}?
          </p>
          <div className="row m-0 w-100">
            <div className="col-12 col-md-6 ps-0 pe-md-2 mb-2 mb-md-0">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={closeHandler}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-md-6 pe-0 ps-md-2">
              <button
                className="btn btn-primary w-100"
                onClick={() => {
                  submitHandler();
                  closeHandler();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default MarkAsInProgressModal;
